var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bag-2",
    "data-name": "bag",
    d: "M17.26,0a3.218,3.218,0,0,0-3.217,3.2V5.088h-3.3a.467.467,0,0,0-.072,0A.751.751,0,0,0,10,5.774L8.491,23.187a.745.745,0,0,0,.2.57A.753.753,0,0,0,9.241,24H27.735a.75.75,0,0,0,.751-.813L26.979,5.774a.752.752,0,0,0-.75-.686h-3.3V3.2A3.214,3.214,0,0,0,19.721,0Zm0,1.5h2.462a1.682,1.682,0,0,1,1.707,1.7V5.088H15.549V3.2A1.686,1.686,0,0,1,17.26,1.5ZM11.435,6.589h2.607V8.813h0a.753.753,0,0,0,1.506,0V6.589h5.879V8.814a.753.753,0,0,0,1.506,0V6.59H25.54L26.912,22.5H10.064Z",
    transform: "translate(-6.488)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.ab3ea38719b2456e9fee3dc54df24f03.svg";
export { ForwardRef as ReactComponent };